var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTables(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 814,
    height: 458,
    viewBox: "0 0 814 458",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 814,
    height: 458,
    fill: "#D5D8DA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 42,
    width: 614,
    height: 390,
    fill: "#B9BFC2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 34,
    width: 614,
    height: 390,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 53,
    width: 77,
    height: 30,
    fill: "#80BDE0"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 125,
    width: 67,
    height: 30,
    fill: "#E9ECEC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 223,
    width: 91,
    height: 30,
    fill: "#E9ECEC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 174,
    width: 74,
    height: 30,
    fill: "#E9ECEC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 272,
    width: 74,
    height: 30,
    fill: "#E9ECEC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 321,
    width: 89,
    height: 30,
    fill: "#E9ECEC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 211,
    y: 370,
    width: 38,
    height: 30,
    fill: "#E9ECEC"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 53,
    width: 132,
    height: 30,
    fill: "#E9ECEC"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 125,
    width: 94,
    height: 30,
    fill: "#E9ECEC"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 223,
    width: 66,
    height: 30,
    fill: "#E9ECEC"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 174,
    width: 114,
    height: 30,
    fill: "#E9ECEC"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 272,
    width: 114,
    height: 30,
    fill: "#E9ECEC"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 321,
    width: 132,
    height: 30,
    fill: "#E9ECEC"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 326,
    y: 370,
    width: 94,
    height: 30,
    fill: "#E9ECEC"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 482,
    y: 53,
    width: 94,
    height: 30,
    fill: "#E9ECEC"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 482,
    y: 125,
    width: 27,
    height: 30,
    fill: "#E0EEF8"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 482,
    y: 223,
    width: 42,
    height: 30,
    fill: "#E0EEF8"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 482,
    y: 174,
    width: 56,
    height: 30,
    fill: "#B3D7EC"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 482,
    y: 272,
    width: 48,
    height: 30,
    fill: "#B3D7EC"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 482,
    y: 321,
    width: 87,
    height: 30,
    fill: "#80BDE0"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 482,
    y: 370,
    width: 48,
    height: 30,
    fill: "#E0EEF8"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 53,
    width: 94,
    height: 30,
    fill: "#E9ECEC"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 125,
    width: 94,
    height: 30,
    fill: "#E9ECEC"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 223,
    width: 94,
    height: 30,
    fill: "#E9ECEC"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 174,
    width: 94,
    height: 30,
    fill: "#E9ECEC"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 272,
    width: 94,
    height: 30,
    fill: "#E9ECEC"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 321,
    width: 94,
    height: 30,
    fill: "#E9ECEC"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 370,
    width: 94,
    height: 30,
    fill: "#E9ECEC"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 53,
    width: 61,
    height: 30,
    fill: "#E9ECEC"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 125,
    width: 61,
    height: 30,
    fill: "#E9ECEC"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 223,
    width: 61,
    height: 30,
    fill: "#E9ECEC"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 174,
    width: 61,
    height: 30,
    fill: "#E9ECEC"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 272,
    width: 61,
    height: 30,
    fill: "#E9ECEC"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 321,
    width: 61,
    height: 30,
    fill: "#E9ECEC"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 370,
    width: 61,
    height: 30,
    fill: "#E9ECEC"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 103,
    width: 614,
    height: 3,
    fill: "#D5D8DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M297.061 81.0607L298.121 80L297.061 78.9393L295.651 77.5293L294.591 76.4696L293.53 77.5284L290.5 80.5533V72V70.5H289H287H285.5V72V80.5441L282.482 77.5203L281.421 76.4577L280.359 77.5193L278.939 78.9393L277.879 80L278.939 81.0607L286.939 89.0607L288 90.1213L289.061 89.0607L297.061 81.0607Z",
    fill: "#4DA3D4",
    stroke: "white",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTables);
export default __webpack_public_path__ + "static/media/tables.d22d9012bf53c5eaab6e505b7fbb8854.svg";
export { ForwardRef as ReactComponent };